<template>
  <div>
    <div
      class="
        d-flex
        flex-column
        pt-5
        pb-5
        bgi-size-cover bgi-no-repeat
        rounded-top
      "
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    >
      <h4 class="d-flex flex-center rounded-top">
        <span class="text-white">اطلاعیه ها</span>
        <span
          class="
            btn btn-text btn-danger btn-sm
            font-weight-bold
            btn-font-md
            ml-2
          "
        >
          {{ loadedCountNotification }}
        </span>
      </h4>

      <!--   <ul
        class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x nav-tabs-line-transparent-white nav-tabs-line-active-border-success mt-3 px-8"
        role="tablist"
      >
        <li class="nav-item">
          <a
            v-on:click="setActiveTab"
            data-tab="0"
            class="nav-link active"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            تسویه ها
          </a>
        </li>
        <li class="nav-item">
          <a
            v-on:click="setActiveTab"
            data-tab="1"
            class="nav-link"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            تیکت ها
          </a>
        </li> -->
      <!-- <li class="nav-item">
          <a
            v-on:click="setActiveTab"
            data-tab="2"
            class="nav-link"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            Logs
          </a>
        </li> 
      </ul>-->
    </div>

    <b-tabs class="hide-tabs" v-model="tabIndex">
      <!-- <b-tab >
        <perfect-scrollbar
          class="navi navi-hover scroll my-4"
          style="max-height: 40vh; position: relative"
        >
          <template v-for="(item, i) in list1">
            <a href="#" class="navi-item" v-bind:key="i">
              <div class="navi-link">
                <div class="navi-icon mr-2">
                  <i v-bind:class="item.icon"></i>
                </div>
                <div class="navi-text">
                  <div class="font-weight-bold">
                    {{ item.title }}
                  </div>
                  <div class="text-muted">
                    {{ item.desc }}
                  </div>
                </div>
              </div>
            </a>
          </template>
        </perfect-scrollbar>
      </b-tab> -->

      <b-tab active>
        <perfect-scrollbar
          class="navi navi-hover scroll my-4"
          style="max-height: 40vh; position: relative"
        >
          <template v-for="(item, i) in loadedListTicket">
            <a  class="navi-item" v-bind:key="i">
              <div class="navi-link">
                <!-- <div class=" mr-2">
                 
                </div> -->
                <div class="navi-text font-weight-bold">
                  <!-- <div class="font-weight-bold"> -->
                  <span
                  :title="item.subject"
                    style="
                      display: inline-block;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      max-width: 13ch;
                    "
                  >
                    {{ item.subject }}
                    <!-- </div> -->
                  </span>
                </div>
                <div class="navi-text text-muted">
                  {{ item.ticket_status.title }}
                </div>
                <div class="navi-icon cursor-pointer">
                  <b-icon-eye-fill @click="test(item.id)" :title="item.subject"></b-icon-eye-fill>
                </div>
              </div>
            </a>
          </template>
        </perfect-scrollbar>
      </b-tab>

      <!-- <b-tab>
        <div class="d-flex flex-center text-center text-muted min-h-200px">
          All caught up!<br />No new notifications.
        </div>
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs > div:not(.tab-content) {
  display: none;
}
</style>

<script>
import httpHelper from "../../../../helpers/httpHelper";
import persianDate from "../../../../helpers/persianDate";
export default {
  name: "KTDropdownNotification",
  data() {
    return {
      tabIndex: 0,
      list1: [
        {
          title: "created_at",
          desc: "description",
          color: "danger",
          icon: "flaticon2-line-chart text-success",
        },
      ],
      list2: [
        {
          title: "New report has been received",
          desc: "23 hrs ago",
          color: "danger",
          icon: "flaticon2-line-chart text-success",
        },
      ],
    };
  },
  methods: {
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      // set current active tab
      event.target.classList.add("active");
    },
    test(id){
        this.$router.push("/ticketDetails/"+id)
}
  },
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/misc/bg-1.jpg";
    },
    loadedListTicket() {
      return this.$store.getters.loadedListTicket;
    },
    loadedCountNotification() {
      return this.$store.getters.loadedCountNotification;
    },
  },
  mounted() {
    httpHelper.getData("message?p=false").then((res) => {
      this.list1 = res.result.map((element) => {
        return {
          desc: persianDate.getDate(element.created_at),
          title: element.description,
          color: "danger",
          icon: "flaticon2-line-chart text-success",
        };
      });
    });
  },
};
</script>
